export default __webpack_public_path__ + "static/media/MarketingList.4ec930f6.svg";